import type { CompareListedProduct } from '@/lib/supabase/get-compare-listed-products'

export interface ComparisonLink {
  /** sorted `a-vs-b` slug, matching /hearing-aids/compare/[slug] */
  slug: string
  label: string
}

// Keep the previous slug order, labels and product-name grouping. Shared by
// the server data adapter and the compact, server-rendered disclosure.
export const popularComparisonLinks = (products: CompareListedProduct[]): ComparisonLink[] => {
  const pairs: ComparisonLink[] = []
  for (let i = 0; i < products.length; i += 1) {
    for (let j = i + 1; j < products.length; j += 1) {
      const [first, second] =
        products[i].productSlug < products[j].productSlug ? [products[i], products[j]] : [products[j], products[i]]
      pairs.push({
        slug: `${first.productSlug}-vs-${second.productSlug}`,
        label: `${first.releaseName} VS ${second.releaseName}`,
      })
    }
  }
  return pairs
}
